export const COMPANY_STATUS = Object.freeze({
  ACCOUNT: 'ACCOUNT',
  CONTACTED: 'CONTACTED',
  DISCARDED: 'DISCARDED',
  ENGAGED: 'ENGAGED',
  MEETING: 'MEETING',
  NURTURING: 'NURTURING',
  ON_PROSPECTION: 'ON_PROSPECTION',
});

export const COMPANY_SALES_STATUS_VALUES_LOGIC_ROLE = Object.freeze({
  ACTIVE: 'COMPANY__SALES_STATUS__ACTIVE',
  ON_HOLD: 'COMPANY__SALES_STATUS__ON_HOLD',
  NURTURING: 'COMPANY__SALES_STATUS__NURTURING',
  DISCARDED: 'COMPANY__SALES_STATUS__DISCARDED',
  CLIENT: 'COMPANY__SALES_STATUS__CLIENT',
});

export const COMPANY_STATUS_LOGIC_ROLE = Object.freeze({
  ACCOUNT: 'COMPANY__STATUS__ACCOUNT',
  CLIENT: 'COMPANY__STATUS__CLIENT',
  CONTACTED: 'COMPANY__STATUS__CONTACTED',
  DELIVERED: 'COMPANY__STATUS__DELIVERED',
  DISCARDED: 'COMPANY__STATUS__DISCARDED',
  ENGAGED: 'COMPANY__STATUS__ENGAGED',
  FINDING_LEADS: 'COMPANY__STATUS__FINDING_LEADS',
  MEETING: 'COMPANY__STATUS__MEETING',
  NURTURING: 'COMPANY__STATUS__NURTURING',
  ON_HOLD: 'COMPANY__STATUS__ON_HOLD',
  ON_PROSPECTION: 'COMPANY__STATUS__ON_PROSPECTION',
  READY_TO_PROSPECT: 'COMPANY__STATUS__READY_TO_PROSPECT',
  NEW: 'COMPANY__STATUS__NEW',
  BACKLOG: 'COMPANY__STATUS__BACKLOG',
});

export const COMPANY_STAGE_LOGIC_ROLE = Object.freeze({
  PROSPECT: 'COMPANY__STAGE__PROSPECTING',
  SALES: 'COMPANY__STAGE__SALES',
});

export const COMPANY_HIGH_PRIORITY_LOGIC_ROLE = Object.freeze({
  NO: 'COMPANY__HIGH_PRIORITY__NO',
  YES: 'COMPANY__HIGH_PRIORITY__YES',
});

export const COMPANY_OPT_OUT_LOGIC_ROLE = Object.freeze({
  NO: 'COMPANY__OPT_OUT__NO',
  YES: 'COMPANY__OPT_OUT__YES',
});

export enum COMPANY_FIELDS_LOGIC_ROLE {
  ASSIGNED_DATE = 'COMPANY__LAST_ASSIGNED_DATE',
  ASSIGNED_TO = 'COMPANY__ASSIGNED_TO',
  ATTEMPTS_COUNT = 'COMPANY__ATTEMPTS_COUNT',
  ATTEMPTS_LAST_DAY = 'COMPANY__ATTEMPTS_LAST_DAY',
  AUTHOR = 'COMPANY__AUTHOR',
  CADENCE_DATA = 'COMPANY__CADENCE_DATA',
  CADENCE_STOPPED = 'COMPANY__CADENCE_STOPPED',
  CADENCE = 'COMPANY__CADENCE',
  COMPANY_PARENT = 'COMPANY__COMPANY_PARENT',
  CONTAINS_INBOUND_LEAD = 'COMPANY__CONTAINS_INBOUND_LEAD',
  COUNTRY = 'COMPANY__COUNTRY',
  CREATION_DATETIME = 'COMPANY__CREATION_DATETIME',
  DISCARDED_REASONS = 'COMPANY__DISCARDED_REASONS',
  EMAIL = 'COMPANY__EMAIL',
  HAS_ATTEMPTS_AFTER_REASSIGN = 'COMPANY__HAS_ATTEMPTS_AFTER_REASSIGN',
  HIGH_PRIORITY = 'COMPANY__HIGH_PRIORITY',
  LINKEDIN_URL = 'COMPANY__LINKEDIN_URL',
  MR_RATING = 'COMPANY__MR_RATING',
  NAME = 'COMPANY__NAME',
  NUMBER_OF_LEADS = 'COMPANY__LEADS_COUNT',
  NURTURING_REASONS = 'COMPANY__NURTURING_REASONS',
  OPT_OUT = 'COMPANY__OPT_OUT',
  ON_HOLD_REASONS = 'COMPANY__ON_HOLD_REASONS',
  QQ_RATING = 'COMPANY__QQ_RATING',
  SALES_STATUS = 'COMPANY__SALES_STATUS',
  SALES_DISCARDED_REASONS = 'COMPANY__SALES_DISCARDED_REASONS',
  SALES_NURTURING_REASONS = 'COMPANY__SALES_NURTURING_REASONS',
  SALES_ON_HOLD_REASONS = 'COMPANY__SALES_ON_HOLD_REASONS',
  SCENARIO = 'COMPANY__SCENARIO',
  SOURCE = 'COMPANY__SOURCE',
  STAGE = 'COMPANY__STAGE',
  START_CADENCE = 'COMPANY__START_CADENCE',
  STATUS = 'COMPANY__STATUS',
  TARGET_MARKET = 'COMPANY__TARGET_MARKET',
  TIME_ZONE = 'COMPANY__TIME_ZONE',
  TOUCHES_COUNT = 'COMPANY__TOUCHES_COUNT',
  TOUCHES_LAST_DAY = 'COMPANY__TOUCHES_LAST_DAY',
  UPDATE_DATETIME = 'COMPANY__UPDATE_DATETIME',
  WEBSITE = 'COMPANY__WEBSITE',
  DATA_SOURCE_AUTOMATED = 'COMPANY__DATA_SOURCE_AUTOMATED',
  IS_INACTIVE = 'COMPANY__IS_INACTIVE',
}
